<template>
  <div class="columns is-multiline is-mobile">
    <div class="column is-half-mobile">
      <window title="Color picker with default value" height="100%">
        <el-color-picker v-model="color1"></el-color-picker>
      </window>
    </div>
    <div class="column is-half-mobile">
      <window title="Color picker without default value" height="100%">
        <el-color-picker v-model="color2"></el-color-picker>
      </window>
    </div>
    <div class="column is-half-mobile">
      <window title="Color picker - Alpha" height="100%">
        <el-color-picker v-model="color3" show-alpha></el-color-picker>
      </window>
    </div>
    <div class="column is-half-mobile">
      <window title="Color picker - Predefined colors" height="100%">
        <el-color-picker v-model="color5" show-alpha :predefine="predefineColors">
        </el-color-picker>
      </window>
    </div>
    <div class="column is-full-mobile">
      <window title="Color picker - Sizes" height="100%">
        <el-color-picker v-model="color4"></el-color-picker>
        <el-color-picker v-model="color4" size="medium"></el-color-picker>
        <el-color-picker v-model="color4" size="small"></el-color-picker>
        <el-color-picker v-model="color4" size="mini"></el-color-picker>
      </window>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      color1: '#409EFF',
      color2: null,
      color3: 'rgba(19, 206, 102, 0.8)',
      color5: 'rgba(255, 69, 0, 0.68)',
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        'hsv(51, 100, 98)',
        'hsva(120, 40, 94, 0.5)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c7158577',
      ],
      color4: '#409EFF',
    };
  },
};
</script>
